import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleEyesYeux7 = customSolarIconWrapper(<g transform="translate(88.5 113)">
	<path d="M42 5L58 21M58 5L42 21" stroke="#202020" strokeWidth="8" strokeLinecap="round" />
	<path d="M5 9L21 25M21 9L5 25" stroke="#202020" strokeWidth="8" strokeLinecap="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleEyesYeux7;
